import { render, staticRenderFns } from "./PlacesTravel.vue?vue&type=template&id=16af2028&scoped=true&"
import script from "./PlacesTravel.vue?vue&type=script&lang=js&"
export * from "./PlacesTravel.vue?vue&type=script&lang=js&"
import style0 from "./PlacesTravel.vue?vue&type=style&index=0&id=16af2028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16af2028",
  null
  
)

export default component.exports